<template>
  <div class="loginWapper">
    
  </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';

export default {
  name: 'Relogin',
  data() {
    return {
      
    };
  },
  components: {},
 async mounted() {
     console.log('11111111',this.$route.query);
     const {routePage,token,} = this.$route.query
    if(!token) {
        this.$router.replace({ path: 'login'})
        return;
    }

    this.$store.commit('User/SET_LOGIN', true);
    this.$store.commit('User/SET_TOKEN', token);
    await this.getAccountInfo();
    routePage && this.$router.replace(routePage)
  },

  methods: {
    async getAccountInfo() {
        const { code, msg = '获取用户信息失败', data } = await requestHttp({
            api: `${qcApi.GET_USER_INFO}`,
            method: 'GET',
        });
        if (code != 1) {
            this.$message.error(msg);
            this.$router.replace('login')
            return;
        }
        this.$store.commit('User/SET_USER_INFO', data);
    },
  },

  destroyed() {
  },
};
</script>
<style lang="less" scoped>

</style>
